<template>
  <div id="app">
    <app-header />
    <div class="app-body">
      <main class="app-main">
        <keep-alive include="ApplyEngineer">
          <router-view />
        </keep-alive>
      </main>
      <app-footer />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
  max-width: 100%;
  overflow: hidden;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-width: 100%;
  overflow: hidden;
}

.app-body {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
}

.app-main {
  min-height: 100%;
  box-sizing: border-box;
}
</style>
